var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { Col as BSCol } from "react-bootstrap";
import { classNames } from "../utils/classNames";
export var Col = function (props) {
    return React.createElement(BSCol, __assign({}, props));
};
export var LeftCol = function (_a) {
    var children = _a.children;
    return (React.createElement(Col, { sm: 4 }, children));
};
export var CentreCol = function (_a) {
    var children = _a.children, full = _a.full;
    return (React.createElement(Col, { sm: full ? 12 : 8 }, children));
};
export var RightCol = function (_a) {
    var children = _a.children;
    return (React.createElement("div", { className: "layout--panel" }, children));
};
export var LayoutContainer = function (_a) {
    var children = _a.children;
    return (React.createElement("div", { className: "layout--content content-container" }, children));
};
export var Page = function (_a) {
    var children = _a.children, _b = _a.className, className = _b === void 0 ? "" : _b;
    return (React.createElement("div", { className: classNames("page", className) }, children));
};
